import { createSlice } from '@reduxjs/toolkit';

const initState = {
    count: 6,
    user: [
        {
            name: 'my name is initialState',
            age: '20'
        }
    ],
    other_name: 'redux',
    infor: {
        info_num: 20,
        info_type: 'sport',
        info_height: 20
    }
}

export const setinitSlice = createSlice({
    name: 'appState',
    initialState: initState,
    reducers: {
        countAdd(state) {
            state.count++;
        },
        setCount(state, action) {
            state.count = action.payload;
        },
        setUser(state, { payload }) {
            state.user.push(payload);
        },
        setName(state, action) {
            state.name = action.payload;
        }
    }
})

export const { countAdd, setCount, setUser, setName } = setinitSlice.actions;
export const setinitState = setinitSlice.reducer;